import React, { useState, useEffect } from 'react';
import { Typography, Upload, Button, Col, Row, Radio } from 'antd';
import { Form, Input, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { submitFeedback } from '../redux/slice';

const { Title, Text } = Typography;

export const FEEDBACK_TYPES = [
  {
    label: 'Appreciation',
    value: 'appreciation'
  },
  {
    label: 'Inquiry',
    value: 'inquiry'
  },
  {
    label: 'Suggestion',
    value: 'suggestion'
  },
  {
    label: 'Complaint',
    value: 'complaint'
  }
];

// rating options
export const RATING_OPTIONS = [
  {
    label: 'Very Satisfied',
    value: 'Very Satisfied'
  },
  {
    label: 'Satisfied',
    value: 'Satisfied'
  },
  {
    label: 'Neutral',
    value: 'Neutral'
  },
  {
    label: 'Dissatisfied',
    value: 'Dissatisfied'
  },
  {
    label: 'Very Dissatisfied',
    value: 'Very Dissatisfied'
  }
];

// recommendation options
export const RECOMMENDATION_OPTIONS = [
  {
    label: 'Definitely',
    value: 'Definitely'
  },
  {
    label: 'Likely',
    value: 'Likely'
  },
  {
    label: 'Neutral',
    value: 'Neutral'
  },
  {
    label: 'Unlikely',
    value: 'Unlikely'
  },
  {
    label: 'Definitely Not',
    value: 'Definitely Not'
  }
];

const Feedback = () => {
  useEffect(() => {
    document.title = 'Share your feedback - Help us improve';
  }, []);

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedFeedback, setSelectedFeedback] = useState([]);
  const { feedbackloading } = useSelector((state) => state.feedback);
  // console.log('feedbackloading', feedbackloading);

  // const handleChange = (checkedValues) => {
  //   setSelectedFeedback(checkedValues);
  // };

  const handleChange = (event) => {
    setSelectedFeedback([event.target.value]);
  };

  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      // console.log('Submitting values:', values);

      const feedbackType = values.feedback_type || '';
      const appreciation_details = values.appreciation_details || '';
      const overallExperience = values.overall_experience || '';
      const recommendUs = values.recommend_us || '';
      const feedbackNote = values.feedback_note || '';
      // const firstFile =
      //   values.attachments?.fileList?.[0]?.originFileObj || null;
      const files = values.attachments?.fileList || [];

      const formData = new FormData();
      formData.append('feedback_type', feedbackType);
      formData.append('overall_experience', overallExperience);
      formData.append('recommend_us', recommendUs);
      formData.append('feedback_description', feedbackNote);
      formData.append('appreciation_details', appreciation_details);

      // Append file if available
      // if (firstFile) {
      //   formData.append('feedback_image', firstFile);
      // }
      files.forEach((file) => {
        formData.append(`feedback_images`, file.originFileObj);
      });

      console.log('Submitting FormData:', formData);

      // Dispatch API call
      const response = await dispatch(submitFeedback(formData));

      if (response?.payload?.success) {
        message.success(
          response?.payload?.message || 'Feedback submitted successfully!'
        );
        navigate(`/dashboard`);
        form.resetFields();
      } else {
        console.error('API call failed:', response?.payload?.message);
        message.error(
          response?.payload?.message || 'Failed to submit feedback.'
        );
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      message.error(error?.message || 'Error submitting feedback.');
    }
  };

  const navigateToDashboard = () => {
    window.location.href = '/dashboard';
  };
  return (
    <div className={styles.maincontainer}>
      <div>
        <Row gutter={24}>
          <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            <div>
              <button className={styles.back} onClick={navigateToDashboard}>
                Back
              </button>
            </div>
          </Col>
          <Col xl={8} lg={24} md={24} sm={24} xs={24}>
            <div className={styles.feedBack}>
              <Title level={2} className={styles.title}>
                Experience Feedback
              </Title>

              <Text className={styles.subtitle}>
                Your feedback helps us improve — share your thoughts and make a
                difference!
              </Text>
            </div>
          </Col>
          <Col xl={16} lg={24} md={24} sm={24} xs={24}>
            <div className={styles.feedForm}>
              <div className={styles.feedback_container}>
                <Form
                  form={form}
                  layout="vertical"
                  className={styles.feedback_form}
                >
                  {/* Feedback Type */}
                  <div className={styles.feedback_section1}>
                    <Form.Item label="Feedback Type" name="feedback_type">
                      <Radio.Group
                        options={FEEDBACK_TYPES}
                        className={styles.custom_checkbox_group}
                        onChange={handleChange}
                        value={selectedFeedback[0]}
                      />
                    </Form.Item>
                    {selectedFeedback.includes('appreciation') && (
                      <Form.Item
                        // label="Appreciation Details"
                        name="appreciation_details"
                      >
                        <Input.TextArea
                          placeholder="Share your appreciation details here..."
                          className={styles.appIn}
                        />
                      </Form.Item>
                    )}
                  </div>

                  {/* Rating and Recommendation */}
                  <div className={styles.feedback_section2}>
                    <Form.Item
                      label="Rate Your Overall Experience"
                      name="overall_experience"
                    >
                      <Radio.Group
                        options={RATING_OPTIONS}
                        className={styles.custom_checkbox_group2}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Would you Recommend Us?"
                      name="recommend_us"
                    >
                      <Radio.Group
                        options={RATING_OPTIONS}
                        className={styles.custom_checkbox_group2}
                      />
                    </Form.Item>

                    {/* Feedback Improvement */}
                    <Form.Item
                      label="What can we improve?"
                      name="feedback_note"
                    >
                      <Input.TextArea
                        placeholder="Share your ideas here...."
                        autoSize
                        className={styles.custom_textarea}
                      />
                    </Form.Item>
                    {/* <span className={styles.attach_text}>
                  Attach images (optional)
                </span> */}
                    {/* File Upload */}
                    <Form.Item
                      label="Attach images (optional)"
                      name="attachments"
                    >
                      <Upload beforeUpload={() => false} multiple>
                        <Button
                          icon={<UploadOutlined />}
                          className={styles.upload_btn}
                        >
                          Click to Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                    <div className={styles.buttonSet}>
                      <Button
                        className="back"
                        onClick={onSubmit}
                        loading={feedbackloading}
                        disabled={feedbackloading}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Feedback;
